module.exports = __webpack_public_path__ + "img/grid_3.798b6046.svg";